export default __webpack_public_path__ + "assets/images/twitter-844b10cf57aade7dbc2fef734a41edba.svg";